const imgPath = '/static/images/about/v2/apps/';

export type TApp = {
    id: number,
    title: string,
    text: string,
    imgLogo: string,
    imgQr: string,
    imgLogoAlt: string,
    imgQrAlt: string,
    btnLink: string,
}

export const appsData: TApp[] = [
    {
        id: 1,
        title: 'Мой Дом.ру',
        text: 'Мобильный личный кабинет. Управляйте услугами и&nbsp;роутером, пополняйте баланс договора и&nbsp;узнавайте о&nbsp;персональных предложениях',
        imgLogo: `${imgPath}1-dom.png`,
        imgQr: `${imgPath}1-dom-qr.png`,
        imgLogoAlt: 'Логотип приложения Мой Дом.ру',
        imgQrAlt: 'QR-код для скачивания приложения Мой Дом.ру',
        btnLink: 'https://app.dom.ru/company',
    },
    {
        id: 2,
        title: 'Умный Дом.ру',
        text: 'Безопасность вашего дома. Открывайте дверь подъезда, отвечайте на&nbsp;звонки и&nbsp;просматривайте камеру на&nbsp;домофоне с&nbsp;телефона. ' +
        'Подключайте и&nbsp;настраивайте камеры видеонаблюдения',
        imgLogo: `${imgPath}2-smart-dom.png`,
        imgQr: `${imgPath}2-smart-dom-qr.png`,
        imgLogoAlt: 'Логотип приложения Умный Дом.ру',
        imgQrAlt: 'QR-код для скачивания приложения Умный Дом.ру',
        btnLink: 'https://redirect.appmetrica.yandex.com/serve/316337496852019161',
    },
    {
        id: 3,
        title: 'Movix — ТВ и фильмы онлайн',
        text: 'Смотрите телеканалы, фильмы и&nbsp;сериалы из&nbsp;онлайн-кинотеатров в&nbsp;одном приложении',
        imgLogo: `${imgPath}3-movix.png`,
        imgQr: `${imgPath}3-movix-qr.png`,
        imgLogoAlt: 'Логотип приложения Movix — ТВ и фильмы онлайн',
        imgQrAlt: 'QR-код для скачивания приложения Movix — ТВ и фильмы онлайн',
        btnLink: 'https://r663z.app.goo.gl/vV1a',
    },
];
